import React, { forwardRef } from 'react';
import { Card } from 'src/design/atoms/Card';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';

interface MainCardProps {
  children: React.ReactNode;
  title?: string;
  darkTitle?: boolean;
  secondary?: React.ReactNode;
  [key: string]: any;
}

const MainCard = forwardRef<HTMLDivElement, MainCardProps>(
  ({ children, title, darkTitle, secondary, ...others }, ref) => {
    return (
      <Card ref={ref} shadow="sm" withBorder {...others}>
        {title && (
          <Card.Section withBorder p="sm">
            {darkTitle ? (
              <Title order={3}>{title}</Title>
            ) : (
              <Text fw={500}>{title}</Text>
            )}
          </Card.Section>
        )}
        {children}
      </Card>
    );
  },
);

MainCard.displayName = 'MainCard';

export default MainCard;
